import { AxiosRequest } from "../common/axios-request";
import { GET_SETTING_CONFIG, UPDATE_SETTING_CONFIG } from "../common/constant";

const GetSettingConfig = () => {
  return AxiosRequest.get(GET_SETTING_CONFIG);
};

const UpdateSettingConfig = (payload: any) => {
  return AxiosRequest.put(UPDATE_SETTING_CONFIG, payload);
};

export { GetSettingConfig, UpdateSettingConfig };
